import {IObservableArray, observable} from "mobx";
import {UsersApi} from "@app/api";
import {MUsers} from "@elte/translate-backend/interface/users";
export import UserData = MUsers.UserData;


export class UsersModel {

    private api: UsersApi;


    constructor() {
        this.api = new UsersApi()
    }


    dataUsers: IObservableArray<UserData> = observable.array([], {deep: false});


    createUserData(data: UserData) {
        return this.api.create(data).then(value => {
            this.dataUsers.push(value);
            return this.dataUsers
        });
    }

    findUser() {
        return this.api.find().then(value => {
            this.dataUsers.replace(value);
            return this.dataUsers
        })
    }


    updateUser(id: UserData['_id'], data: UserData):Promise<MUsers.UserData> {
        return this.api.patch(id, data).then(value => {
            const findIndex = this.dataUsers.findIndex(value1 => value1._id === id);

            this.dataUsers.spliceWithArray(findIndex,1,[value]);

            return value;
        })
    }



}
